<template>
  <v-dialog v-model="visible" max-width="1200px" persistent scrollable>
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <!-- Información del Programa -->
            <v-col cols="12" class="pb-0">
              <span class="text-subtitle-2 font-weight-medium grey--text text--darken-1">
                Información del Programa
              </span>
              <v-divider class="mt-1"></v-divider>
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="form.sedeUniversidadId"
                :items="sedesUniversidadesFiltradasPorUniversidad"
                item-text="nombre"
                item-value="id"
                label="Sede Universidad*"
                outlined
                dense
                hide-details="auto"
                :error-messages="errores.sedeUniversidadId"
                clearable
                @change="obtenerAreasYCategoriasUniversidadesYPlanesPagos">
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle class="subtitle-2 text-uppercase">
                      <small>{{ item.institucion.nombre }}</small>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="form.codigo"
                label="Código*"
                outlined
                dense
                hide-details="auto"
                :error-messages="errores.codigo"
                clearable></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                v-model="form.modalidad"
                :items="modalidadesProgramasUniversidadesOpciones"
                label="Modalidad*"
                outlined
                dense
                hide-details="auto"
                :error-messages="errores.modalidad"
                clearable></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.programaNombre"
                label="Programa*"
                outlined
                dense
                hide-details="auto"
                :error-messages="errores.programaNombre"
                clearable></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="form.version"
                type="text"
                label="Versión*"
                outlined
                dense
                hide-details="auto"
                :error-messages="errores.version"
                clearable></v-text-field>
            </v-col>

            <!-- Clasificación y Gestión -->
            <v-col cols="12" class="pb-0">
              <span class="text-subtitle-2 font-weight-medium grey--text text--darken-1">
                Clasificación y Gestión
              </span>
              <v-divider class="mt-1"></v-divider>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="form.areaUniversidadId"
                :items="areasUniversidades"
                label="Área*"
                outlined
                dense
                hide-details="auto"
                :error-messages="errores.areaUniversidadId"
                item-text="nombre"
                item-value="id"
                clearable
                :disabled="areasUniversidades.length == 0">
              </v-select>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="form.categoriaUniversidadId"
                :items="categoriasUniversidades"
                label="Tipo*"
                outlined
                dense
                hide-details="auto"
                :error-messages="errores.categoriaUniversidadId"
                item-text="nombre"
                item-value="id"
                clearable
                :disabled="categoriasUniversidades.length == 0"></v-select>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="form.gestion"
                :items="gestiones"
                label="Gestión*"
                outlined
                dense
                hide-details="auto"
                :error-messages="errores.gestion"
                item-text="gestion"
                item-value="gestion"
                clearable></v-select>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="form.grupo"
                type="number"
                min="1"
                label="Grupo"
                outlined
                dense
                hide-details="auto"
                :error-messages="errores.grupo"
                clearable></v-text-field>
            </v-col>

            <v-col cols="12" md="8">
              <v-text-field
                v-model="form.resolucionAprobacionUniversidad"
                label="Resolución Aprobación Universidad*"
                outlined
                dense
                hide-details="auto"
                :error-messages="errores.resolucionAprobacionUniversidad"
                clearable></v-text-field>
            </v-col>

            <!-- Fechas y Plan de Pago -->
            <v-col cols="12" class="pb-0">
              <span class="text-subtitle-2 font-weight-medium grey--text text--darken-1">
                Fechas y Plan de Pago
              </span>
              <v-divider class="mt-1"></v-divider>
            </v-col>

            <v-col cols="12" md="4">
              <v-menu
                ref="menuFechaInicioRef"
                v-model="menuFechaInicio"
                transition="scale-transition"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaInicio"
                    label="Fecha Inicio"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                    hide-details="auto"
                    :error-messages="errores.fechaInicio"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="form.fechaInicio" no-title scrollable @input="menuFechaInicio = false">
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="menuFechaInicio = false"> Cancelar </v-btn>

                  <v-btn text color="primary" @click="$refs.menuFechaInicioRef.save(form.fechaInicio)"> Aceptar </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="4">
              <v-menu
                ref="menuFechaFinRef"
                v-model="menuFechaFin"
                transition="scale-transition"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaFin"
                    label="Fecha Fin"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                    hide-details="auto"
                    :error-messages="errores.fechaFin"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="form.fechaFin" no-title scrollable @input="menuFechaFin = false">
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="menuFechaFin = false"> Cancelar </v-btn>

                  <v-btn text color="primary" @click="$refs.menuFechaFinRef.save(form.fechaFin)"> Aceptar </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="4">
              <v-menu
                ref="menuFechaInscripcionRef"
                v-model="menuFechaInscripcion"
                transition="scale-transition"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaInscripcion"
                    label="Fecha Inscripción"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                    hide-details="auto"
                    :error-messages="errores.fechaInscripcion"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker
                  v-model="form.fechaInscripcion"
                  no-title
                  scrollable
                  @input="menuFechaInscripcion = false">
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="menuFechaInscripcion = false"> Cancelar </v-btn>

                  <v-btn text color="primary" @click="$refs.menuFechaInscripcionRef.save(form.fechaInscripcion)">
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12">
              <vue-select
                v-model="form.planPagoUniversidadId"
                class="style-chooser"
                placeholder="Seleccione un Plan de Pago"
                :options="planesPagosUniversidades"
                label="nombre"
                :append-to-body="true"
                :reduce="(option) => option.id"
                clearable
                :disabled="planesPagosUniversidades.length == 0">
                <template #option="{ nombre, planesPagosConceptosUniversidades }">
                  <div style="padding-bottom: 0.5rem">
                    <strong style="display: block; font-size: 1.125rem">{{ nombre }}</strong>

                    <TablaPlanesPagosConceptosUniversidades
                      :planesPagosConceptosUniversidades="planesPagosConceptosUniversidades" />
                  </div>
                </template>
              </vue-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="enviando"
          :loading="enviando"
          text
          @click.prevent="validar(registrar, editar)">
          Guardar
        </v-btn>

        <v-btn color="error" :disabled="enviando" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ProgramaUniversidadService from '../services/programa-universidad.service';
import SedeUniversidadService from '../services/sede-universidad.service';
import CategoriaUniversidadService from '../services/categoria-universidad.service';
import AreaUniversidadService from '../services/area-universidad.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import GestionService from '../services/gestion.service';
import PlanPagoUniversidadService from '../services/plan-pago-universidad.service';
import TablaPlanesPagosConceptosUniversidades from './TablaPlanesPagosConceptosUniversidades.vue';
import { modalidadesProgramasUniversidadesOpciones } from '../utils/constantes';

export default {
  name: 'ModalFormularioProgramaUniversidad',
  mixins: [modalFormMixin, apiConsumerMixin],
  components: {
    TablaPlanesPagosConceptosUniversidades,
  },
  data() {
    return {
      categorias: [],
      areasUniversidadesSinMapeo: [],
      areasUniversidades: [],
      categoriasUniversidades: [],
      sedesUniversidades: [],
      planesPagosUniversidades: [],
      menuFechaInicio: false,
      menuFechaFin: false,
      menuFechaInscripcion: false,
      gestiones: [],
      modalidadesProgramasUniversidadesOpciones: modalidadesProgramasUniversidadesOpciones,
    };
  },
  watch: {
    'form.codigo': function () {
      this.errores.codigo = [];
    },
    'form.programaNombre': function () {
      this.errores.programaNombre = [];
    },
    'form.gestion': function () {
      this.errores.gestion = [];
    },
    'form.resolucionAprobacionUniversidad': function () {
      this.errores.resolucionAprobacionUniversidad = [];
    },
    'form.version': function () {
      this.errores.version = [];
    },
    'form.modalidad': function () {
      this.errores.modalidad = [];
    },
    'form.areaUniversidadId': function () {
      this.errores.areaUniversidadId = [];
    },
    'form.fechaInicio': function () {
      this.errores.fechaInicio = [];
    },
    'form.fechaFin': function () {
      this.errores.fechaFin = [];
    },
    'form.categoriaUniversidadId': function () {
      this.errores.categoriaUniversidadId = [];
    },
    'form.fechaInscripcion': function () {
      this.errores.fechaInscripcion = [];
    },
    'form.sedeUniversidadId': function () {
      this.errores.sedeUniversidadId = [];
    },
    'form.grupo': function () {
      this.errores.grupo = [];
    },
    'form.planPagoUniversidadId': function () {
      this.errores.planPagoUniversidadId = [];
    },
  },
  computed: {
    sedesUniversidadesFiltradasPorUniversidad() {
      const universidadId = this.$store.state.convenio.id;

      if (!universidadId) return [];

      return this.sedesUniversidades.filter((s) => s.universidadId === universidadId);
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        codigo: null,
        programaNombre: null,
        gestion: null,
        resolucionAprobacionUniversidad: null,
        version: null,
        modalidad: null,
        areaUniversidadId: null,
        fechaInicio: null,
        fechaFin: null,
        estado: null,
        categoriaUniversidadId: null,
        fechaInscripcion: null,
        sedeUniversidadId: null,
        grupo: null,
        planPagoUniversidadId: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        programaNombre: data.programaNombre,
        gestion: data.gestion,
        resolucionAprobacionUniversidad: data.resolucionAprobacionUniversidad,
        version: data.version,
        modalidad: data.modalidad,
        areaUniversidadId: data.areaUniversidadId,
        fechaInicio: data.fechaInicio,
        fechaFin: data.fechaFin,
        estado: data.estado,
        categoriaUniversidadId: data.categoriaUniversidadId,
        fechaInscripcion: data.fechaInscripcion,
        sedeUniversidadId: data.sedeUniversidadId,
        grupo: data.grupo,
        planPagoUniversidadId: data.planPagoUniversidadId,
      };
    },
    async obtenerAreasUniversidades(sedeUniversidadId) {
      this.areasUniversidades = [];

      if (!sedeUniversidadId) {
        return;
      }

      const sedeUniversidad = this.sedesUniversidades.find((sede) => sede.id == sedeUniversidadId);

      if (!sedeUniversidad) {
        return;
      }

      const params = {
        universidadId: sedeUniversidad.universidadId,
      };

      await this.obtenerDatosMixin(
        AreaUniversidadService.findAll,
        'areasUniversidadesSinMapeo',
        params,
        () => {},
        () => {
          this.areasUniversidades = this.areasUniversidadesSinMapeo.map((area) => ({
            id: area.id,
            nombre: area.nombre,
            tipo: area.tipo,
            nombreTipo: `${area.nombre} (${area.tipo.toUpperCase()})`,
          }));
        },
      );
    },
    async obtenerCategoriasUniversidades(sedeUniversidadId) {
      this.categoriasUniversidades = [];

      if (!sedeUniversidadId) {
        return;
      }

      const sedeUniversidad = this.sedesUniversidades.find((sede) => sede.id == sedeUniversidadId);

      if (!sedeUniversidad) {
        return;
      }

      const params = {
        universidadId: sedeUniversidad.universidadId,
      };

      await this.obtenerDatosMixin(CategoriaUniversidadService.findAll, 'categoriasUniversidades', params);
    },
    async obtenerAreasYCategoriasUniversidades(sedeUniversidadId) {
      await this.obtenerAreasUniversidades(sedeUniversidadId);
      await this.obtenerCategoriasUniversidades(sedeUniversidadId);
    },
    async obtenerAreasYCategoriasUniversidadesYPlanesPagos(sedeUniversidadId) {
      await this.obtenerAreasYCategoriasUniversidades(sedeUniversidadId);
      await this.obtenerPlanesPagosUniversidades(sedeUniversidadId);
    },
    async obtenerSedesUniversidades() {
      await this.obtenerDatosMixin(SedeUniversidadService.findAll, 'sedesUniversidades');
    },
    async obtenerGestiones() {
      await this.obtenerDatosMixin(GestionService.findAll, 'gestiones');
    },
    async obtenerPlanesPagosUniversidades(sedeUniversidadId) {
      this.planesPagosUniversidades = [];

      if (!sedeUniversidadId) {
        return;
      }

      const sedeUniversidad = this.sedesUniversidades.find((sede) => sede.id == sedeUniversidadId);

      if (!sedeUniversidad) {
        return;
      }

      const params = {
        universidadId: sedeUniversidad.universidadId,
      };

      await this.obtenerDatosMixin(PlanPagoUniversidadService.findAll, 'planesPagosUniversidades', params);
    },
    abrir(accion, data = []) {
      this.obtenerSedesUniversidades().then(() => {
        if (accion == this.accionesCrud.EDITAR) {
          Promise.all([
            this.obtenerAreasYCategoriasUniversidadesYPlanesPagos(data?.sedeUniversidadId),
            this.obtenerGestiones(),
          ]).then(() => {
            this.abrirMixin(accion, data);
          });
        } else {
          Promise.all([this.obtenerGestiones()]).then(() => {
            this.abrirMixin(accion, data);
          });
        }
      });
    },
    async registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    async editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
    async guardar(accion) {
      this.guardarDatosMixin(
        ProgramaUniversidadService.create,
        ProgramaUniversidadService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.areasUniversidades = [];
          this.categoriasUniversidades = [];
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>